import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent() {
    return (
        <Svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
        >
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.846 2.91l-.871.87 11.208 11.21.871-.872L3.846 2.91z"
                fill="#000"
            />
            <Path
                d="M4.815 5.62l.82.82A9.493 9.493 0 003.56 8.988l-.002.003c1.287 2.15 3.327 4.183 5.903 3.874a5.104 5.104 0 001.936-.66l.83.829c-1.155.741-2.479 1.134-3.914.94-2.587-.35-4.702-2.472-6.035-4.964.626-1.26 1.482-2.464 2.536-3.39zM6.68 4.405A5.951 5.951 0 019.02 3.88c.047 0 .598.026.848.067.156.026.312.058.466.098 2.454.64 4.272 2.828 5.415 4.965-.48.969-1.107 1.8-1.856 2.61l-.796-.795c.554-.597 1.02-1.17 1.374-1.815 0 0-.361-.664-.632-1.024a10.68 10.68 0 00-.55-.674 18.704 18.704 0 00-.881-.873c-.942-.81-2.048-1.445-3.374-1.434a4.517 4.517 0 00-1.476.28l-.88-.88z"
                fill="#000"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.047 7.853l.674.674a1.362 1.362 0 001.72 1.72l.675.674a2.256 2.256 0 01-3.069-3.069zm1.926-1.154h.042a2.256 2.256 0 012.254 2.254v.042L8.973 6.699z"
                fill="#000"
            />
        </Svg>
    )
}

export default SvgComponent
